/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_PricesInputs */

const en_col_prices = /** @type {(inputs: Col_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prices`)
};

/**
* | output |
* | --- |
* | "Prices" |
*
* @param {Col_PricesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const col_prices = /** @type {((inputs?: Col_PricesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_PricesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_col_prices(inputs)
});